import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { HeadMenuComponent } from './shared/header-menu/header-menu.component';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeadMenuComponent, RouterLinkActive, RouterLink],
  templateUrl: './app.html',
  styleUrl: './app.css'
})

export class App {
  title = 'FarmacioaPVR'

}
